package com.essntl.features.tag.ui.addedittag.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.features.tag.ui.addedittag.AddEditTagEvent
import com.essntl.features.tag.ui.addedittag.AddEditTagScreen
import com.essntl.features.tag.ui.addedittag.AddEditTagState
import com.essntl.features.tag.ui.addedittag.AddEditTagValidation
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddEditTagDialog(
    openDialog: Boolean,
    tag: TagModel? = null,
    state: AddEditTagState,
    validation: AddEditTagValidation,
    onEvent: (AddEditTagEvent) -> Unit,
    onDismissRequest: () -> Unit,
    modifier: Modifier = Modifier,
) {
    LaunchedEffect(openDialog) {
        if (openDialog) {
            onEvent(AddEditTagEvent.ClearState)
            if (tag != null)
                onEvent(AddEditTagEvent.GetTag(tag.id))
        }
    }

    if (openDialog)
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
            ),
            modifier = modifier.fillMaxSize(0.3f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = if (tag != null) "Edit tag" else "Add new tag",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    AddEditTagScreen(
                        state = state,
                        validation = validation,
                        onEvent = onEvent,
                    )
                }
            }
        }
}